import { useEffect, useState } from "react";
import { LockKey, CircleNotch } from "@phosphor-icons/react";
import api, { apiError } from "../lib/api";
import { fmtBRL } from "../lib/format";
import { onReauthRequest, storeReauthToken } from "../lib/reauth";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Dialog, DialogPortal, DialogOverlay, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const ReauthDialog = () => {
  const [req, setReq] = useState(null);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => onReauthRequest((r) => { setReq(r); setPassword(""); setError(""); }), []);

  const finish = (token) => { req?.resolve(token); setReq(null); };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/reauth", { password });
      storeReauthToken(data.reauth_token, data.expires_in);
      finish(data.reauth_token);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  const d = req?.detail || {};
  return (
    <Dialog open={!!req} onOpenChange={(v) => { if (!v) finish(null); }}>
      <DialogPortal>
        <DialogOverlay className="z-[100]" />
        <DialogPrimitive.Content data-testid="reauth-dialog"
          className="fixed left-1/2 top-1/2 z-[101] w-full max-w-md -translate-x-1/2 -translate-y-1/2 grid gap-4 border border-zinc-800 bg-zinc-950 text-zinc-50 p-6 shadow-lg sm:rounded-lg data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><LockKey size={20} className="text-amber-400" /> Confirme sua senha</DialogTitle>
          <DialogDescription className="text-zinc-400">
            {d.acao || "Operação"} de <b className="text-zinc-100">{fmtBRL(d.total)}</b> — acima do limite de {fmtBRL(d.limite)}.
            Por segurança, confirme a senha da sua conta para continuar (válido por 5 minutos).
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="reauth-password-input" type="password" autoFocus autoComplete="current-password" required
            className="w-full bg-zinc-900 border border-zinc-800 rounded px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500"
            placeholder="Senha da sua conta" value={password} onChange={(e) => setPassword(e.target.value)} />
          {error && <p data-testid="reauth-error" className="text-sm text-rose-400 bg-rose-400/10 border border-rose-400/20 rounded px-3 py-2">{error}</p>}
          <div className="flex gap-2">
            <button data-testid="reauth-confirm-button" disabled={busy || !password}
              className="flex-1 inline-flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-500 disabled:opacity-50 text-white text-sm font-medium py-2.5 rounded transition-colors">
              {busy ? <CircleNotch size={15} className="animate-spin" /> : <LockKey size={15} weight="bold" />} Confirmar e continuar
            </button>
            <button type="button" data-testid="reauth-cancel-button" onClick={() => finish(null)}
              className="px-4 border border-zinc-700 hover:bg-zinc-800 text-zinc-300 text-sm rounded transition-colors">Cancelar</button>
          </div>
        </form>
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>
  );
};
